import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import ReactHtmlParser from 'react-html-parser';

import AdviceSection from '../common/AdviceSection';
import SubMenuTabs from '../common/subMenuTabs/SubMenuTabs';
import SelectEconomic from '../common/select-filters/SelectEconomic';
import DatasetSelectTrend from '../common/select-filters/DatasetSelectTrend';
import SpiderChart from '../common/charts/SpiderChart';
import SpiderBarChart from '../common/charts/SpiderBarChart';
import MentalRiskCharts from '../common/charts/MentalRiskCharts';
import TrendDiagram from '../common/charts/TrendDiagram';
import Methodology from '../common/Methodology';
import Related from '../common/Related';

import { physicalRiskTabs } from '../../model/subMenuTabs';

import { setCountry1, setCountry2, setCountry3 } from '../../actions/';

const PhysicalRisk = props => {

	let selected='', selectedSecondLevel = '', secondLevel = '';
	for (let i = 0; i < physicalRiskTabs.length; i++)
	{
		if (physicalRiskTabs[i].url == props.tab)
		{
			selected = physicalRiskTabs[i];
		}
	}

	// If the current tab has sub-tabs, set the selected one
	if (selected.subTabs != undefined)
	{
		secondLevel = selected.subTabs;
		for (let i = 0; i < secondLevel.length; i++)
		{
			if (secondLevel[i].url == props.indicator)
			{
				selectedSecondLevel = secondLevel[i];
			}
		}
	}

	const currentPath = '/working-conditions-preventions/physical-risk/';

	// Get global state for the selects
	const { selectCountry, selectCountry2, selectCountry3, selectedByUser, lockedCountry } = useSelector((state) => state.selectCountries);
	const [countryLocked, setCountryLocked] = useState(lockedCountry != 'IS' ? lockedCountry : 'AT');
	const [chart, setChart] = useState('20049');
	const [secondLevelTabs, setSecondLevelTabs] = useState(secondLevel);
	const [selectedTab, setSelectedTab] = useState(selected);
	const [secondLevelSelectedTab, setSecondLevelSelectedTab] = useState(selectedSecondLevel);
	const [chartLegend, setChartLegend] = useState('');
	const [selectedSurvey, setSelectedSurvey] = useState('');
	const [isSubMenuOpen, setIsSubMenuOpen] = useState(false);
	const [chartDimension, setChartDimension] = useState(window.innerWidth > 768 ? 'column' : 'bar');
	const [showSecondLevel, setShowSecondLevel] = useState(secondLevel == '' ? false : true);
	const [dataset, setDataset] = useState(props.dataset);
	const [secondLevelIndicator, setSecondLevelIndicator] = useState(props.indicator ? props.indicator : 'vapours');
	const [fullyLoaded, setFullyLoaded] = useState(true);
	const [isTrend, setIsTrend] = useState(false);
	const [selectedAnswer, setSelectedAnswer] = useState(undefined);
	const [selectedDataset1, setSelectedDataset1] = useState(undefined);
	const [selectedDataset2, setSelectedDataset2] = useState(undefined);
	const [selectedSortBy, setSelectedSortBy] = useState(false);
	const [spiderChart, setSpiderChart] = useState(true);
	
	// Hook for the dispatchs
	const dispatch = useDispatch();

	useEffect(() => {
		if(!dataset){
			if(!secondLevelSelectedTab){
				setDataset(selectedTab.chartType[0].type);
			}else{
				setDataset(secondLevelSelectedTab.chartType[0].type);
			}			
		}
		setFullyLoaded(true);

		try {
			if (!selectedByUser) {
				if (props.country1 != undefined && props.country1 != 'IS') {
					dispatch(setCountry1(props.country1))
				} else {
					dispatch(setCountry1('AT'))
				}
			}
		} catch (err) {
			console.log('error', err.message)
		} finally {
			setFullyLoaded(false);
		}

		if (props.country2 != undefined && props.country2 != '') {
			dispatch(setCountry2(props.country2))
		}

		if (props.country3 != undefined && props.country3 != '') {
			dispatch(setCountry3(props.country3))
		}

		if (selectedByUser) {
			if (selectCountry2 == lockedCountry) {
				dispatch(setCountry2(''))
			}

			if (selectCountry3 == lockedCountry) {
				dispatch(setCountry3(''))
			}
		}

		// Update the title of the page
		document.title = props.literals.L22013 +  " - " + props.literals.L22020 + " - " + props.literals.L363;

		window.addEventListener('resize', updateDimension);
		if(selectedTab == 'smoke-powder-or-dust'){
			setShowSecondLevel(true);
			setSelectedTab('smoke-powder-or-dust');
			setChartLegend('20598');
		}
	}, [])

	useEffect(() => {
		if (!selectedByUser) {
			if (selectCountry == 'IS') {
				dispatch(setCountry1('AT'));
			}
		}
	}, [props.selectCountry])

	useEffect(() => {
		dispatch(setCountry2(props.country2))
	}, [props.selectCountry2]);

	useEffect(() => {
		dispatch(setCountry3(props.country3))
	}, [props.selectCountry3]);

	const handleSearch = (callbackCountry1) => {
		if (selectedByUser) {
			setCountryLocked(callbackCountry1);
		} else {
			dispatch(setCountry1(callbackCountry1));
		}
	}

	const handleSearch2 = (callbackCountry2) => {
		dispatch(setCountry2(callbackCountry2));
	}

	const handleSearch3 = (callbackCountry3) => {
		dispatch(setCountry3(callbackCountry3));
	}

	const callbackSelectedSurvey = (callback) => {
		setDataset(callback);
		// Set the dataset 1 as undefined to prevent wrong data from loading
		setSelectedDataset1(undefined);
	}

	const callbackSelectedTab = (callback) => {
		if (callback == 'exposure-to-dangerous-substances')
		{
			setShowSecondLevel(true);
			for (let i = 0; i < physicalRiskTabs.length; i++)
			{
				if (callback == physicalRiskTabs[i].url)
				{
					let selected = physicalRiskTabs[i];
					setSelectedTab(selected);
					setSecondLevelTabs(selected.subTabs);
					if (secondLevelSelectedTab == undefined || secondLevelSelectedTab == '')
					{
						setSecondLevelSelectedTab(selected.subTabs[0]);
						setDataset(selected.subTabs[0].chartType[0].type);
					}
				}
			}
		}
		else
		{
			setShowSecondLevel(false);
			for (let i = 0; i < physicalRiskTabs.length; i++)
			{
				if (callback == physicalRiskTabs[i].url)
				{
					setSelectedTab(physicalRiskTabs[i]);
				}
			}
		}	
	}
	
	const callbackChartLegend = (legend) => {
		setChartLegend(legend);
	}

	const callbackSelectedIndicator = (callback) => {
		// This function will be called when changing the indicator for Exposure to Dangerous Substances
		setSecondLevelIndicator(callback);
		for (let i = 0; i < secondLevelTabs.length; i++)
		{
			if (callback == secondLevelTabs[i].url)
			{
				setSecondLevelSelectedTab(secondLevelTabs[i]);
				setIsTrend(false);
			}
		}
	}

	const updateDimension = ()=>{
		if(window.innerWidth > 768){
			setChartDimension('column');
		}else{
			setChartDimension('bar');
		}
	}

	const handleTrendButton = () => {
		setIsTrend(!isTrend);
	}

	const handleAnswerChange = (callback) => {
		setSelectedAnswer(callback);
	}

	const handleDatasetChange1 = (dataset, indicator) => {
		setSelectedDataset1(dataset);
	}

    const handleDatasetChange2 = (dataset, indicator) => {
		setSelectedDataset2(dataset);
	}

    const handleSortButton = () => {
		setSelectedSortBy(!selectedSortBy);
    }

	// Change from Spider Chart to Column Chart and Vice Versa
	const handleSpiderButton = () =>
	{
		setSpiderChart(!spiderChart);
	}

	let submenu = '';
	const selectCountry1 = selectedByUser ? lockedCountry : selectCountry
	// If the current tab has another menu inside, it will display the menu
	if (showSecondLevel)
	{
		submenu = <SubMenuTabs 
			literals={ props.literals }
			selectedTab={ secondLevelSelectedTab.url }
			selectedSurvey={ selectedSurvey } 
			callbackSelectedTab={ callbackSelectedIndicator }
			locationPath={`${currentPath}exposure-to-dangerous-substances/`}
			subMenuTabs={ secondLevelTabs } 
		/>
	}
	// If not, it will display the select with the countries for the selected chart and indicators
	else
	{
		let currentChart = selectedTab.chartType.length == 1 ? selectedTab.chartType[0].chart : selectedTab.chartType.find((element) => element.type == dataset).chart;
		let currentIndicator = selectedTab.chartType.length == 1 ? selectedTab.chartType[0].chartIndicator : selectedTab.chartType.find((element) => element.type == dataset).chartIndicator;

		submenu = <SelectEconomic 
			handleSearch={ handleSearch } 
			handleSearch2={ handleSearch2 } 
			handleSearch3={ handleSearch3 } 
			charts={ [currentChart] }
			indicator={ currentIndicator }
			literals={ props.literals }
			selectedCountry1={ selectCountry1 }
			selectedCountry2={ selectCountry2 }
			selectedCountry3={ selectCountry3 }
		/> 
	}

	let divTrendOrBarChart;

	if(isTrend){
		divTrendOrBarChart = (
			<TrendDiagram
				literals={ props.literals }
				tabIndicator={ secondLevelSelectedTab.literalTab }
				chartType={ secondLevelSelectedTab.chartType }
				selectedIndicator={ dataset }
				selectedAnswer={ selectedAnswer }
				selectedDataset1={ selectedDataset1 }
				selectedDataset2={ selectedDataset2 }
				colors={ ['#f6a300', '#cbe2e3'] }
				type={ chartDimension }
			/>
		)
	}else{
		divTrendOrBarChart = (
			<MentalRiskCharts
				literals={ props.literals }
				tabIndicator={ secondLevelSelectedTab.literalTab }
				chartType={ secondLevelSelectedTab.chartType }
				colors={ ['#cbe2e3','#f6a400'] }
				type={ chartDimension }
				percentage={ true }
				callbackLegend={ callbackChartLegend }
				callbackSelectedSurvey={ callbackSelectedSurvey }
				exportingEnabled={ true }
				showSelect={ true }
				showDataset={ true }
				selectedSortBy={ selectedSortBy }
				selectedDataset={ selectedDataset1 }
			/>
		)
	}

	return(
		<div className="physical-risk">
			<AdviceSection literals={ props.literals } section={["working-conditions-preventions","physical-risk"]} methodologyData={{section: 'working-conditions-preventions', subsection: 'Working conditions - Physical risk', indicator: 67}} />
			<div>
				<SubMenuTabs 
					literals={ props.literals }
					selectedTab={ selectedTab.url }
					callbackSelectedTab={ callbackSelectedTab }
					locationPath={ currentPath }
					subMenuTabs={ physicalRiskTabs } 
					selectCountry1={ selectCountry1 }
					selectCountry2={ selectCountry2 }
					selectCountry3={ selectCountry3 }
					selectedSurvey={ dataset }
				/>
			</div>
			<div>
				<div className="line background-main-light" />
				{ submenu }
			</div>

			<div className="line background-main-light" />

			<DatasetSelectTrend
				literals={ props.literals }
				chartType={ showSecondLevel ? secondLevelSelectedTab.chartType : selectedTab.chartType }
				callbackSelectedSurvey={ callbackSelectedSurvey }
				handleAnswerChange={ handleAnswerChange }
				handleDatasetChange1={ (e) => handleDatasetChange1(e) }
				handleDatasetChange2={ (e) => handleDatasetChange2(e) }
				showSourceSelect={ selectedTab.url == 'ergonomic-risks' ? true : false }
				showAnswerSelect={ isTrend }
				yearOnly={ selectedTab.url == 'ergonomic-risks' ? true : false }
				selectedIndicator={ selectedTab.url == 'ergonomic-risks' ? dataset : null }
			/>

			<div className="line background-main-light"></div>

			<div className="container section--page card--grid xxs-w1 xs-w1 w1 center-text">
				<div className="card--block--chart with-filters">
					{ showSecondLevel ? 
						<React.Fragment>
							<div className='card--btn-wrapper'>
								<div className="select-filter-chart-wrapper">								
									{ !isTrend && <div className="switch--button">
										<input type="checkbox" name="switch-button" id="switch-label" 
										className="switch--button-checkbox" defaultChecked={ selectedSortBy } />
										<label htmlFor="switch-label" className="switch--button-label" onClick={ handleSortButton }></label>
										<label htmlFor="switch-label" className="text-label" onClick={ handleSortButton }>{ props.literals["L20341"] }</label>
									</div>}
								</div>
								<div className='btn-trend-container'>
									<a className="btn-default btn-main-color ng-binding btn-trend" onClick={ handleTrendButton }>
										{ !isTrend ? props.literals["L20287"] : props.literals["L20311"] }
									</a>
								</div>
							</div>
							<div className="chart--block">						
								<div className="card--block--chart--wrapper" >
									<div className="chart--wrapper" >
										{ divTrendOrBarChart }
									</div>
								</div>							
							</div>
						</React.Fragment>
						
					: 
						<React.Fragment>
							<div className='card--btn-wrapper'>
								<div className='btn-trend-container'>
									<a className="btn-default btn-main-color ng-binding btn-trend" onClick={ handleSpiderButton }>{ spiderChart ? props.literals["L20311"] : props.literals["L20641"] }</a>
								</div>
							</div>
							<div className="chart--wrapper spider-chart" >
								{ spiderChart ? 
										<SpiderChart
											literals={ props.literals }
											tabIndicator={ selectedTab.literalTab }
											selectCountry1={ selectCountry1 }
											selectCountry2={ selectCountry2 }
											selectCountry3={ selectCountry3 }
											showDataLabel={ true }
											colors={ ['#f6a400','#529FA2','#7b7b7d','#003399'] }
											chartType={ selectedTab.chartType }
											callbackLegend={ callbackChartLegend }
											datasetSource={ dataset }
											datasetID={ selectedDataset1 }
											exportingEnabled={ true }
										/>
									:
										<SpiderBarChart 
											literals={ props.literals }
											type={ "column" }
											chartType={ selectedTab.chartType }
											datasetSource={ dataset }
											datasetID={ selectedDataset1 }
											selectCountry1={ selectCountry1 }
											selectCountry2={ selectCountry2 }
											selectCountry3={ selectCountry3 }
											percentage={"%"}
											colors={ ['#ffae00','#529FA2','#7B7B7D'] }
										/>
									}
							</div>
						</React.Fragment>
					}
				</div>
				<div className="chart-legend">
					{ReactHtmlParser( props.literals[`L${chartLegend}`] ) }
				</div>
			</div>

			<Methodology literals={ props.literals } section={'Working conditions - Physical risk'} indicator={ showSecondLevel ? secondLevelSelectedTab.chartType[0].chartIndicator : null} 
				dataset={ showSecondLevel ? null : dataset } subsection={ showSecondLevel ? null : props.tab } />

			{showSecondLevel ? 
				<Related literals={ props.literals } section={["working-conditions-preventions","physical-risk", "exposure-to-dangerous-substances" ]} /> 
				: null
			}
		</div>
	)
}
PhysicalRisk.displayName = 'PhysicalRisk';
export default PhysicalRisk;